import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53ef1bae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container main-width license-container news-table d-flex flex-column position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "position-absolute top-0 left-0 w-100 h-100 spin-wrapper d-flex align-items-center justify-content-center"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3 me-auto-sm fs-18" }, "年份", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "全部", -1))
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_content_table = _resolveComponent("content-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_spin, { indicator: _ctx.indicator }, null, 8, ["indicator"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex mb-40", [_ctx.isShowBorder && 'table-title-container-border']])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["fs-36 table-title text-elite-blue fw-bold pb-2 fs-28-md fs-21-sm", [_ctx.isShowBorder && 'table-title-border']])
      }, _toDisplayString(_ctx.title), 3)
    ], 2),
    (_ctx.isShowFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
            class: "form-select select-box py-3 ps-4 text-elite-blue fs-14",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChangeYear && _ctx.handleChangeYear(...args)))
          }, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
              return (_openBlock(), _createElementBlock("option", {
                key: year,
                value: year
              }, _toDisplayString(year) + " 年度 ", 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedYear]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_content_table, {
      createdAtKey: _ctx.createdAtKey,
      newsList: _ctx.contents,
      onClickItem: _cache[2] || (_cache[2] = (data) => _ctx.$emit('click-item', data))
    }, null, 8, ["createdAtKey", "newsList"]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}